import React from 'react';
import MaterialTable from 'material-table';
import { calculateHeight } from 'common/services/util';
import TableTitle from 'common/components/TableTitle';

const TablePublicReac = ({ columns, loading, data }) => (
    <MaterialTable
        title={<TableTitle>Dispositivos Reacondicionados</TableTitle>}
        columns={columns}
        data={data}
        isLoading={loading}
        options={{
            sorting: true,
            filtering: true,
            search: false,
            pageSize: 50,
            pageSizeOptions: [10, 25, 50, 100],
            maxBodyHeight: calculateHeight(),
            actionsColumnIndex: -1,
        }}
        localization={{
            body: { emptyDataSourceMessage: 'No hay dispositivos disponibles' },
            toolbar: { searchPlaceholder: 'Buscar' },
            pagination: {
                labelRowsSelect: 'filas',
                labelDisplayedRows: '{from}-{to} de {count}',
                firstTooltip: 'Primera página',
                previousTooltip: 'Anterior',
                nextTooltip: 'Siguiente',
                lastTooltip: 'Última página',
            },
        }}
    />
);

export default TablePublicReac;
